<template>
  <v-main>
    <v-card class="ma-3">
      <v-card-title> Confirmación masiva </v-card-title>
      <v-card-text>
        Enviará a cada usuario que haya utilizado la aplicación un resumen del
        resultado de la gestión realizada.
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          text
          disabled
          outlined
          rounded
          color="primary"
          @click="sendMassiveReport"
          >Enviar Mensajes</v-btn
        >
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title> Cierre de plataforma </v-card-title>
      <v-card-text>
        <v-textarea
          placeholder="Escribe aquí el mensaje que verán los padres cuando intenten acceder a la plataforma"
          label="mensaje"
          v-model="closedMessage"
        >
        </v-textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-switch
          label="activar"
          v-model="closeFamilies"
          @change="updateClosed"
        ></v-switch>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>Vaciar grupos</v-card-title>
      <v-card-text>
        Elimina los alumnos de los grupos en todas las actividades (necesario al comenzar cada nuevo curso).
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="initGroups" disabled>Vaciar</v-btn>
      </v-card-actions>
    </v-card>
    <v-card>
      <v-card-title>
        Cargar tokens no utilizados
        <v-spacer></v-spacer>
        <v-btn @click="loadBrokenTokens">Cargar</v-btn>
      </v-card-title>
      <v-card-text>
        <v-toolbar flat height="40" :key="tokenIndex" v-for="(token,tokenIndex) in brokenTokens">
          {{token.email}} <v-spacer></v-spacer> {{ showDate(token.created) }}
        </v-toolbar>
      </v-card-text>
      <span :key="emailIndex" v-for="(email,emailIndex) in brokenEmails">{{email}}, </span>
      {{brokenEmails.length}}
    </v-card>
    <v-card>
      <v-card-title>Mensajes</v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn disabled @click="restoreData" color="primary" rounded>Restaurar base de datos</v-btn>
        <v-btn disabled @click="deleteConfirmations" color="primary" rounded>Eliminar confirmaciones</v-btn>
        <v-btn disabled @click="loadComments" color="primary" rounded>Cargar comentarios</v-btn>
      </v-card-actions>
      <v-card-text v-if="!commentsReady">
        <div :key="messageIndex" v-for="(message,messageIndex) in messages">
          <div>{{message.email}}</div>
          <div v-html="message.message"></div>
          <v-divider></v-divider>
        </div>
      </v-card-text>
      <v-card-text v-else>
        <div :key="activityIndex" v-for="(activity,activityIndex) in activities">
          {{ activity}}
          <v-spacer></v-spacer>
          <v-btn @click="addActivity(activity)">Agregar</v-btn>
        </div>
      </v-card-text>
    </v-card>
  </v-main>
</template>

<script>
/* eslint-disable no-console */
import {
  newId,
  fs,
  auth,
  tokens,
  students,
  activities,
  messages,
  properties,
} from "../firebaseConfig.js";
import moment from "moment";

export default {
  data() {
    return {
      sended: [],
      closedMessage: "",
      messages: [],
      comments: [],
      commentsReady: false,
      closeFamilies: false,
      activities: [],
      restored: 0,
      brokenTokens: [],
      brokenEmails: [],
    };
  },
  created() {
    this.loadMessages();
    if (!auth.currentUser) this.$router.replace("/login");
    properties
      .doc("closemessage")
      .get()
      .then((messageRef) => {
        if (messageRef.exists) {
          (this.closedMessage = messageRef.data().message),
            (this.closeFamilies = messageRef.data().active);
        }
      });
  },
  methods: {
    showDate(date) {
      return moment(date.seconds*1000).format('LLL')
    },
    loadBrokenTokens() {
      this.brokenTokens = [];
      this.brokenEmails = [];
      tokens.orderBy('created').get().then((tokensQuery) => {
        tokensQuery.forEach((tokenQuery) => {
          messages.where('email', '==', tokenQuery.data().email).get().then((messagesQuery) => {
            if (messagesQuery.size === 0 && tokenQuery.data().email) {
              console.log(messagesQuery.size)
              this.brokenTokens.push(tokenQuery.data())
              if(this.brokenEmails.indexOf(tokenQuery.data().email) === -1) this.brokenEmails.push(tokenQuery.data().email)
            }
          })
        })
      })
    },
    restoreData() {
      this.restored = 0;
      messages.get().then((messagesQuery) => {
        messagesQuery.forEach(async (messageQuery) => {
          this.restored++;
          console.log(messageQuery.data().email, this.restored);
          let theMessage = { message: messageQuery.ref.id, activities: [] }
          let data = messageQuery.data().message.split('<p>')[5];
          let d = data.split('<b class="gray">')[1].split('</b>')[0].split(' ')
          let date = new Date(new Date().getFullYear(),8,d[0],parseInt(d[5].split(':')[0]),parseInt(d[5].split(':')[1].split('h')[0]),0)
          let fatherQuery = await students.where('fatherEmail', '==', messageQuery.data().email).get()
          let fatherSons = fatherQuery.docs.map((doc) => doc.data());
          let motherQuery = await students.where('motherEmail', '==', messageQuery.data().email).get()
          let motherSons = motherQuery.docs.map((doc) => doc.data());
          let sons = fatherSons.concat(motherSons);
          let sonParts = data.split('<h3 class="son-name">');
          let activitiesLength = messageQuery.data().message.split('<li><h4>').length-1;
          let theActivities = [];
          for (let i = 1; i < sonParts.length; i++) {
            let name = sonParts[i].split('</h3>')[0]
            let theSon = {};
            sons.forEach((son) => {
              if (son.name.split(',')[1].trim() === name) {
                theSon = son
              }
            })
            let activitiesParts = sonParts[i].split('</h3>')[1].split('<h4>')
            for (let j = 1; j < activitiesParts.length; j++) {
              let activityName = activitiesParts[j].split('</h4>')[0];
              let activityComment = activitiesParts[j].split('</h4>')[1].split('Observaciones: </b>')[1].split('</li>')[0];
              activityComment === 'No se añadió ninguna observación' ? activityComment = '' : null;
              let activityRef = await activities.where('name', '==', activityName).get()
              console.log(activityName,activityRef.size);
              let groupsParts = activitiesParts[j].split('<span class="group">')
              let theGroups = [];
              for (let k = 1; k < groupsParts.length; k++) {
                let groupSchedule = groupsParts[k].split('</span>')[0];
                //if (activityRef.docs.length > 0) {
                Object.values(activityRef.docs[0].data().groups).forEach((group) => {
                  console.log(group.schedule.trim(),'patata',groupSchedule.split('('+group.name+')')[0].trim())
                  if (group.schedule.trim() === groupSchedule.split('('+group.name+')')[0].trim()) {
                      console.log('coinciden')
                      theGroups.push({
                        id: group.id,
                        schedule: groupSchedule,
                        student: {
                          email: messageQuery.data().email,
                          group: theSon.group,
                          id: theSon.id,
                          name: theSon.name,
                          parentGender: messageQuery.data().email === theSon.fatherEmail ? 'male' : 'female',
                          parentName: messageQuery.data().email === theSon.fatherEmail ? theSon.fatherName : theSon.motherName,
                          index: 0,
                          priority: 1,
                          comments: activityComment,
                          date
                        }
                      })
                    }
                  })                  
                }
              //}
              theActivities.push({
                id: activityRef.docs[0].data().id,
                name: activityRef.docs[0].data().name,
                groups: theGroups,
              })
              if (theActivities.length === activitiesLength) {
                theMessage.activities = theActivities;
                console.log('Escribiendo', theMessage);
                theMessage.activities.forEach((activity) => {
                  activity.groups.forEach((group) => {
                    activities.doc(activity.id).update({
                      [`groups.${group.id}.students.${group.student.id}`]: group.student
                    })
                  })
                })
                messages.doc(theMessage.message).update({
                  restored: new Date()
                })
              }
            }
          }
        })
      })
    },
    deleteConfirmations() {
      let total = 0;
      let removable = 0;
      messages.get().then((messagesQuery) => {
        messagesQuery.forEach((messageQuery) => {
          total++
          if (!messageQuery.data().id) {
            removable++
            messages.doc(messageQuery.ref.id).delete()
          }
        })
        console.log(total, removable);
      })
    },
    addActivity(activity) {
      activities.where('name','==',activity.name).get().then((activitiesQuery)=>{
        console.log(activity.name,activitiesQuery.size);
        if(activitiesQuery.size === 0) {
          activities.doc(activity.id).set(activity).then(()=>{
            console.log(`${activity.name} creado con éxito`)
          })
        }
      })
    },
    addComment(comment) {
      comment.activitiesList.forEach((activity)=>{
        console.log(activity.id,activity.comment)
        if(activity.id && activity.comment !== 'No se añadió ninguna observación') {
          activities.doc(activity.id).update({
            [`comments.${comment.id}`]: activity.comment
          }).then(()=>{
            comment.ready = true
            console.log('Comentarios actualizados');
          })
        }
      })
    },
    parseMessage(message) {
      return message;
    },
    parseDate(date) {
      let year = '2021';
      let month = 0
      switch(date.split(' ')[2]) {
        case 'enero': month = 0; break;
        case 'febrero': month = 1; break;
        case 'marzo': month = 2; break;
        case 'abril': month = 3; break;
        case 'mayo': month = 4; break;
        case 'junio': month = 5; break;
        case 'julio': month = 6; break;
        case 'agosto': month = 7; break;
        case 'septiembre': month = 8; break;
        case 'octubre': month = 9; break;
        case 'noviembre': month = 10; break;
        case 'diciembre': month = 11;
      }
      let day = date.split(' ')[0];
      let hour = date.split(' ')[5].split(':')[0];
      let minutes = date.split(' ')[5].split(':')[1].split('h')[0]
      return new Date(year,month,day,hour,minutes,0);
    },
    loadComments() {
      let comments = [];
      this.messages.forEach((message)=>{
        
        let theMessage = message.message;
        let dateString = '';
        let date = null
        if(theMessage.includes('Fecha de la gestión: <b class="gray">')) {
          dateString = theMessage.split('Fecha de la gestión: <b class="gray">')[1].split('</b>')[0];
          date = this.parseDate(dateString);
        }
        let sons = theMessage.split('<h3 class="son-name">');
        if(sons.length > 1) {
          sons.shift();
          sons.forEach((son)=>{
            let sonData = son.split('<style>')[0]
            let name = sonData.split('</h3>')[0];
            let theActivities = sonData.split('</h3>')[1].split('<li><h4>')
            theActivities.shift();
            let activitiesList = [];
            theActivities.forEach((activity)=>{
              let activityName = activity.split('</h4>')[0];
              let groupData = activity.split('</h4>')[1].split('<p class="gray"><b>Grupos: </b>')[1].split('</p>')[0].split('<span class="group">')[1].split('</span>')[0].replace('  ',' ');
              let schedule = groupData.split(' ')[0] + ' ' + groupData.split(' ')[1].trim();
              let groupName = '';
              if(groupData.includes('(')) {
                groupName = groupData.split('(')[1].split(')')[0]
              }
              let activityComment = activity.split('Observaciones: </b>')[1].split('</li>')[0]
              activitiesList.push({
                name: activityName,
                schedule,
                groupName,
                comment: activityComment,
              })
            })
            let theSon = {
              name, activitiesList
            }
            students.where('motherEmail','==',message.email).get().then((mStudentsQuery)=>{
              if(mStudentsQuery.size) {
                mStudentsQuery.forEach((studentQuery)=>{
                  if(studentQuery.data().name.split(', ')[1] === theSon.name) {
                    theSon.id = studentQuery.data().id
                    theSon.fullName = studentQuery.data().name
                    theSon.group = studentQuery.data().group
                    theSon.parentGender = 'female'
                    theSon.parentName = studentQuery.data().motherName
                    theSon.email = message.email
                    theSon.date = date;
                    theSon.activitiesList.forEach((activity)=>{
                      activities.where('name','==',activity.name).get().then((activitiesQuery)=>{
                        if(activitiesQuery.size > 0) {
                          activity.id = activitiesQuery.docs[0].data().id
                        } else {
                          activity.id = null
                        }
                      })
                    })
                    comments.push(theSon)
                  }
                })
              } else {
                students.where('fatherEmail','==',message.email).get().then((fStudentsQuery)=>{
                  fStudentsQuery.forEach((studentQuery)=>{
                    if(studentQuery.data().name.split(', ')[1] === theSon.name) {
                      theSon.id = studentQuery.data().id
                      theSon.fullName = studentQuery.data().name
                      theSon.group = studentQuery.data().group
                      theSon.parentGender = 'male'
                      theSon.parentName = studentQuery.data().fatherName
                      theSon.email = message.email
                      theSon.date = date
                      theSon.activitiesList.forEach((activity)=>{
                        activities.where('name','==',activity.name).get().then((activitiesQuery)=>{
                          if(activitiesQuery.size > 0) {
                            activity.id = activitiesQuery.docs[0].data().id
                          } else {
                            activity.id = null
                          }
                        })
                      })
                      comments.push(theSon)
                    }
                  })                
                })
              }
            })
          })
        }
        /*students.where('motherEmail','==',message.email).get().then((mStudentsQuery)=>{
          if(mStudentsQuery.size > 0) {
            mStudentsQuery.forEach((studentQuery)=>{
              theStudents[studentQuery.data().id] = {
                id: studentQuery.data().id,
                activity: null,
                comment: this.parseMessage(message.message),
              }
            });
            console.log(theStudents);
          } else {
            students.where('fatherEmail','==',message.email).get().then((fStudentsQuery)=>{
              fStudentsQuery.forEach((studentQuery)=>{
                theStudents[studentQuery.data().id] = {
                  id: studentQuery.data().id,
                  activity: null,
                  comment: this.parseMessage(message.message),
                }
              });
              console.log(theStudents);
            });
          }
        })*/
      })
      setTimeout(()=>{
        let theComments = [];
        comments.forEach((comment)=>{
          if(theComments.indexOf(comment.id) === -1) {
            theComments.push(comment.id)
            this.comments.push(comment)
          }
        })
        //this.comments = comments;
        //console.log(this.comments);
        this.makeGroups()
        //this.commentsReady = true; 
      },10000);
    },
    makeGroups() {
      let activities = {}
      this.comments.forEach((comment)=>{
        comment.activitiesList.forEach((activity)=>{
          if(activity.id === null) {
            if(!activities[activity.name]) {
              activities[activity.name] = {
                id: newId(), 
                name: activity.name, 
                description: '', 
                comments: {}, 
                images: [],
                max: '15', 
                min: '5',
                published: false,
                groups: {},
                target: [],
                targets: [],
              }
            }
            if(!activities[activity.name].groups[activity.schedule]) {
              activities[activity.name].groups[activity.schedule] = {
                date: new Date(),
                id: newId(),
                schedule: activity.schedule,
                students: {},
              }
              if(activity.groupName !== '') {
                activities[activity.name].groups[activity.schedule].name = activity.groupName
              }
            }
            activities[activity.name].groups[activity.schedule].students[comment.id] = {
              date: comment.date,
              email: comment.email,
              group: comment.group,
              id: comment.id,
              name: comment.fullName,
              parentGender: comment.parentGender,
              parentName: comment.parentName,
              priority: 1,
            }
            if(activity.comment !== '' && activity.comment !== 'No se añadió ninguna observación') {
              activities[activity.name].comments[comment.id] = activity.comment;
            }
            if(activities[activity.name].targets.indexOf(comment.group) === -1) {
              activities[activity.name].targets.push(comment.group);
            }
          }
        })
      })
      let theActivities = []
      Object.values(activities).forEach((activity)=>{
        let theGroups = {}
        Object.values(activity.groups).forEach((group)=>{
          theGroups[group.id] = group;
          theGroups[group.id].students = Object.values(group.students).sort((a,b)=>{
            return a.date < b.date ? -1 : 1;
          });
          theGroups[group.id].students.forEach((student,index)=>{
            student.index = index
          })
        })
        activity.groups = theGroups;
        theActivities.push(activity);
      })
      this.activities = theActivities;
      this.commentsReady = true;
    },
    loadMessages() {
      messages.get().then((messagesQuery)=>{
        this.messages = [];
        messagesQuery.forEach((messageQuery)=>{
          this.messages.push(messageQuery.data())
        })
      })
    },
    initGroups() {
      activities.get().then((activitiesQuery)=>{
        activitiesQuery.forEach((activityQuery)=>{
          let groups = activityQuery.data().groups || {};
          Object.keys(groups).forEach((group)=>{
            activities.doc(activityQuery.data().id).update({
              [`groups.${group}`]: fs.FieldValue.delete(),
              comments: {}
            })
          })
        })
      })
    },
    updateClosed() {
      if (this.closeFamilies) {
        properties.doc("closemessage").set({
          message: this.closedMessage,
          active: true,
        });
      } else {
        properties.doc("closemessage").set({
          message: this.closedMessage,
          active: false,
        });
      }
    },
    sendMassiveReport() {
      tokens.get().then((tokensRef) => {
        tokensRef.forEach((tokenRef) => {
          if (this.sended.indexOf(tokenRef.data().email) < 0) {
            setTimeout(() => {
              this.getToken(tokenRef);
            }, 5000);
          }
          this.sended.push(tokenRef.data().email);
        });
      });
    },
    getToken(tokenRef) {
      students
        .where("fatherEmail", "==", tokenRef.data().email)
        .get()
        .then((studentsRef) => {
          if (studentsRef.size > 0) {
            this.getSons(
              studentsRef,
              tokenRef.data().email,
              tokenRef.data().created
            );
          } else {
            students
              .where("motherEmail", "==", tokenRef.data().email)
              .get()
              .then((studentsRef) => {
                this.getSons(
                  studentsRef,
                  tokenRef.data().email,
                  tokenRef.data().created
                );
              });
          }
        });
    },
    getSons(studentsRef, email, date) {
      let sons = [];
      studentsRef.forEach((student) => {
        let son = { ...student.data(), activities: [] };
        sons.push(son);
        activities
          .where("targets", "array-contains", son.group)
          .where("published", "==", true)
          .get()
          .then((activitiesRef) => {
            son.activities = [];
            activitiesRef.forEach((activity) => {
              let theGroups = [];
              Object.values(activity.data().groups).forEach((group) => {
                let enrolled = Object.keys(group.students).indexOf(son.id) >= 0;
                theGroups.push({
                  id: group.id,
                  name: group.name,
                  schedule: group.schedule,
                  date: group.date.seconds,
                  enrolled,
                });
              });
              let theActivity = {
                id: activity.data().id,
                name: activity.data().name,
                images: activity.data().images,
                description: activity.data().description,
                groups: theGroups.sort((a, b) => {
                  if (a.date < b.date) {
                    return -1;
                  } else {
                    return 1;
                  }
                }),
                comments:
                  (activity.data().comments &&
                    activity.data().comments[son.id]) ||
                  "",
              };
              son.activities.push(theActivity);
            });
          });
      });
      this.prepareParentData(sons, email, date);
    },
    prepareParentData(sons, email, date) {
      let parent = {
        email,
        date,
      };
      students
        .where("fatherEmail", "==", email)
        .get()
        .then((studentsRef) => {
          if (studentsRef.size > 0) {
            parent.name =
              this.showName(studentsRef.docs[0].data().fatherName) || "padre";
            parent.gender = "male";
            this.prepareConfirmationMessage(parent, sons);
          } else {
            students
              .where("motherEmail", "==", email)
              .get()
              .then((studentsRef) => {
                parent.name =
                  this.showName(studentsRef.docs[0].data().motherName) ||
                  "madre";
                parent.gender = "female";
                this.prepareConfirmationMessage(parent, sons);
              });
          }
        });
    },
    prepareConfirmationMessage(parent, sons) {
      let message = ``;
      message = `<p>Estimad${parent.gender === "male" ? "o" : "a"} ${
        parent.name
      }:</p>`;
      message +=
        "<p>Ayer inauguramos una nueva plataforma para gestionar las actividades extraescolares de los alumnos del colegio.</p>";
      message +=
        "<p>Poco después de abrir el plazo de inscripciones la aplicación registró un pequeño número de incidencias producidas por la alta demanda del servicio. Algunas familias nos advirtieron de ello, les agradecemos enormemente los comentarios recibidos y ya estamos trabajando para evitar problemas similares en el futuro.</p>";
      message +=
        "<p>Aunque creemos que todas las altas se registraron correctamente, le enviamos este correo con el resultado de la gestión.</p>";
      message +=
        "<p>Por favor, revise que todo es correcto. Si encuentra alguna discrepancia comuniquenosló respondiendo a este correo y resolveremos la incidencia manteniendo la fecha en que se realizó la gestión inicial.</p>";
      message += `<p>También puede ponerse en contacto con nosotros si tiene cualquier otra consulta, estaremos encantados de atenderle.</p>`;
      message += `<p>Fecha de la gestión: <b class="gray">${moment(
        new Date(parent.date.seconds * 1000)
      ).format("D [de] MMMM [a las] HH:mm[h]")}</b></p>`;

      let nSons = 0;
      sons.forEach((son) => {
        let nActivities = 0;
        son.activities.forEach((activity) => {
          let nGroup = 0;
          activity.groups.forEach((group) => {
            if (group.enrolled) nGroup++;
          });
          if (nGroup > 0) nActivities++;
        });
        if (nActivities > 0) nSons++;
      });
      if (nSons) {
        sons.forEach((son) => {
          let nActivities = 0;
          son.activities.forEach((activity) => {
            let nGroup = 0;
            activity.groups.forEach((group) => {
              if (group.enrolled) nGroup++;
            });
            if (nGroup > 0) nActivities++;
          });
          if (nActivities) {
            message += `<h3 class="son-name">${this.showName(son.name)}</h3>`;
            message += `<ul>`;
            son.activities.forEach((activity) => {
              let nGroups = 0;
              activity.groups.forEach((group) => {
                if (group.enrolled) nGroups++;
              });
              if (nGroups > 0) {
                message += `<li><h4>${activity.name}</h4>`;
                message += `<p class="gray"><b>Grupos: </b>`;
                activity.groups.forEach((group) => {
                  if (group.enrolled) {
                    message += `<span class="group">${
                      group.schedule ? group.schedule : "Sin horario confirmado"
                    } ${group.name ? " (" + group.name + ")" : ""}</span>`;
                  }
                });
                message += `</p><b class="gray">Observaciones: </b>${
                  activity.comments !== ""
                    ? activity.comments
                    : "No se añadió ninguna observación"
                }`;
                message += "</li>";
              }
            });
            message += `</ul>`;
          }
        });
      } else {
        message += `<p>Actualmente no tiene hijos matriculados en ninguna actividad.</p>`;
      }
      message += `<br><p>Un saludo.</p>`;
      message += `
                <style>
                .gray {
                    color: grey;
                }
                .group {
                    border: 1px solid lightgrey;
                    padding: 0px 5px 0px 5px;
                    margin: 0px 5px 0px 5px;
                    border-radius: 5px;
                }
                .son-name {
                    color: grey;
                    margin-top: 20px;
                    border-bottom: 1px solid lightgrey;
                }
                </style>
            `;
      let id = newId();
      let theMessage = {
        id,
        email: parent.email,
        message,
      };
      messages
        .doc(id)
        .set(theMessage)
        .then(() => {
          console.log("Mensaje enviado");
        });
    },
    showName(name) {
      if (name.includes(",")) {
        return name.split(",")[1].trim();
      } else {
        return name;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>